/**
 * Parse a Tjommie device QR URL and return { serial_number, imsi_number }.
 * Returns null (never throws) if the URL does not match the expected format.
 *
 * Expected shape: any URL whose slash-separated segments have
 *   segment[5] = serial_number  and  segment[6] = imsi_number.
 */
export function parseDeviceQr(url) {
  if (!url || typeof url !== "string") return null;
  const parts = url.split("/");
  if (parts.length < 7) return null;
  const serial_number = parts[5];
  const imsi_number = parts[6];
  if (!serial_number || !imsi_number) return null;
  return { serial_number, imsi_number };
}
